import GenericDB from './generic-db';

export default class UsersDeletionsDB extends GenericDB {
  constructor() {
    super('usersDeletions');
  }
}
